var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_591_9767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5983 13C20.4392 13 13 20.4392 13 29.5983C13 38.7575 26.5936 52.3511 28.1478 53.8638C28.5415 54.2575 29.0803 54.4648 29.5983 54.4648C30.1164 54.4648 30.6137 54.2783 31.0074 53.9053C32.5616 52.4547 46.1967 39.4413 46.1967 29.6191C46.176 20.4392 38.7367 13 29.5983 13ZM29.5983 39.1305C24.3349 39.1305 20.0662 34.8617 20.0662 29.5983C20.0662 24.3349 24.3349 20.0662 29.5983 20.0662C34.8617 20.0662 39.1305 24.3349 39.1305 29.5983C39.1305 34.8617 34.8617 39.1305 29.5983 39.1305Z",
    fill: "#041A39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_591_9767",
    x: 0,
    y: 0,
    width: 63.1963,
    height: 71.4609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.419608 0 0 0 0 0.847059 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_591_9767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_591_9767",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerLightMode);
export default __webpack_public_path__ + "static/media/markerLightMode.f57b0d8d486b5e1abf52799d0951d8bd.svg";
export { ForwardRef as ReactComponent };